import { render, staticRenderFns } from "./rm-request-responder.vue?vue&type=template&id=3cf00128&scoped=true"
import script from "./rm-request-responder.vue?vue&type=script&lang=ts"
export * from "./rm-request-responder.vue?vue&type=script&lang=ts"
import style0 from "./rm-request-responder.vue?vue&type=style&index=0&id=3cf00128&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf00128",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cf00128')) {
      api.createRecord('3cf00128', component.options)
    } else {
      api.reload('3cf00128', component.options)
    }
    module.hot.accept("./rm-request-responder.vue?vue&type=template&id=3cf00128&scoped=true", function () {
      api.rerender('3cf00128', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/management-request/rm-request-responder.vue"
export default component.exports